import React from 'react'
import Loading from "../../components/common/Loading";
import dynamic from "next/dynamic";
import Head from 'next/head';

const MobileRetailStores = dynamic(() => import('../../components/UAEPages/retailPage/MobileRetailPage'), {
    loading: () => <Loading />

});
const DesktopRetailStores = dynamic(() => import('../../components/UAEPages/retailPage/DektopRetailPage'), {
    loading: () => <Loading />

});


const RetailStores = ({ mobileView }) => {
  return (
    <div>
      <Head>
        <title>Retail POS Software UAE | Smart VAT Billing & Inventory</title>
        <meta name="description" content="QueueBuster POS for UAE retail stores with VAT billing, inventory control, CRM, eStore, and multi-store management. Boost sales with fast, accurate retail billing"/>
        <link rel="canonical" href="https://queuebuster.co/ae-en/retail-stores" />
        <link rel="alternate" href="https://queuebuster.co/ae-en/retail-stores" hrefLang="en" />
        <meta property="og:title" content="QueueBuster Retail POS UAE – Smart VAT Billing, Inventory & CRM Solution"/>
        <meta property="og:description" content="QueueBuster POS is built for UAE retail stores—from supermarkets to fashion outlets. Manage VAT billing, central inventory, CRM, eStore, and multi-store operations in one powerful platform. Scale faster with real-time analytics and seamless automation."/>
        <meta property="og:image" content="https://quebuster.s3.ap-south-1.amazonaws.com/website/assets/OG+Image+UAE.png" />
        <meta property="og:url" content="https://queuebuster.co/ae-en/retail-stores" />

      </Head>
        {mobileView ? <MobileRetailStores /> : <DesktopRetailStores />}
    </div>
  )
}

export default RetailStores